// Wachtwoord herstellen (met token) — M115 safety-follow-up
import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Loader2, KeyRound } from "lucide-react";


export default function ResetPasswordPage() {
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const [ok, setOk] = useState(false);
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";

  useEffect(() => {
    if (!token) setErr("Geen geldige token in de URL. Vraag een nieuwe herstellink aan.");
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return setErr("Kies een wachtwoord van minimaal 8 tekens.");
    if (pw !== pw2) return setErr("Wachtwoorden komen niet overeen.");
    setBusy(true); setErr(null);
    try {
      await api.post("/auth/password-reset/confirm", { token, new_password: pw });
      setOk(true);
      setTimeout(() => nav("/login"), 3000);
    } catch (e) {
      setErr(e?.response?.data?.detail || "Ongeldig of verlopen reset-token.");
    }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="reset-page" className="min-h-screen flex items-center justify-center bg-bg-canvas px-4">
      <div className="w-full max-w-md rounded-md border border-border-hairline bg-bg-panel p-6">
        <h1 className="text-2xl font-semibold text-text-primary mb-1" data-testid="reset-title">
          Kies een nieuw wachtwoord
        </h1>
        <p className="text-sm text-text-muted mb-4">
          Uw nieuwe wachtwoord moet minimaal 8 tekens lang zijn.
        </p>

        {err && <div data-testid="reset-error" className="p-3 mb-3 rounded border border-neg-red/40 bg-neg-red/10 text-xs text-neg-red">{err}</div>}
        {ok && <div data-testid="reset-success" className="p-3 mb-3 rounded border border-pos-green/40 bg-pos-green/10 text-xs text-pos-green">Wachtwoord aangepast. U wordt doorgestuurd naar het inlogscherm.</div>}

        {!ok && (
          <form onSubmit={submit}>
            <label className="text-[10px] text-text-muted">Nieuw wachtwoord</label>
            <input type="password" value={pw} onChange={e => setPw(e.target.value)} required minLength={8}
                    data-testid="reset-password-input"
                    className="w-full mt-1 mb-3 bg-bg-panel-raised border border-border-hairline rounded px-2 py-1.5 text-sm" />
            <label className="text-[10px] text-text-muted">Bevestig wachtwoord</label>
            <input type="password" value={pw2} onChange={e => setPw2(e.target.value)} required minLength={8}
                    data-testid="reset-password-confirm-input"
                    className="w-full mt-1 mb-3 bg-bg-panel-raised border border-border-hairline rounded px-2 py-1.5 text-sm" />
            <button type="submit" disabled={busy || !token}
                      data-testid="reset-submit-btn"
                      className="w-full h-10 rounded-md bg-accent-teal hover:bg-accent-teal-dim disabled:opacity-60 text-white text-sm font-semibold inline-flex items-center justify-center gap-1.5">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" />}
              Wachtwoord bijwerken
            </button>
          </form>
        )}

        <div className="mt-4 text-center">
          <Link to="/login" data-testid="reset-back-to-login" className="text-xs text-text-muted hover:text-accent-teal underline">
            Terug naar inloggen
          </Link>
        </div>
      </div>
    </div>
  );
}
